<template>
  <div class="label">
    <div class="by">
      <h1>标准标签 <el-button
          @click="add"
          class="fr"
          type="primary"
          size="small"
        >创建标签</el-button>
      </h1>

      <div class="clearfix">
        <div
          class="box fl"
          v-for="i in 10"
          :key="i"
        >
          <h2>朗读流利</h2>
          <h3>表扬类型： 1</h3>
          <h3>提醒类型： 1</h3>
        </div>
      </div>
    </div>

    <!-- 新增的对话框 -->
    <el-dialog
      class="add-pop"
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      :showClose="false"
      top="10%"
    >
      <template v-slot:title>
        <div class="add-title">编辑标签 </div>
      </template>
      <div>
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="120px"
        >

          <el-form-item
            label="标签名称"
            prop="labelName"
          >
            <el-input
              size="small"
              placeholder="不能超过10个字"
              v-model="form.labelName"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button
            type="text"
            class="del-btn"
            @click="del"
          >删除此项</el-button>
          <el-button
            round
            @click="cancel"
            class="cle-btn"
            size="small"
          >取 消</el-button>
          <el-button
            round
            @click="submit"
            type="primary"
            class="sub-btn"
            size="small"
          >确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import IconUpload from "@/components/upload/IconUpload.vue";
export default {
  components: {
    IconUpload,
  },
  computed: {
    // ...mapState([
    // ]),
  },
  data() {
    return {
      addVisible: false,
      form: {
        labelName: "",
      },
      rules: {
        labelName: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    add() {
      this.addVisible = true;
    },
    del() {},
    cancel() {
      this.addVisible = false;
    },
    submit() {},
    uploadSucess() {},
  },
};
</script>

<style lang="less" scoped>
.label {
  background-color: #fff;
  padding: 15px;
  .by {
    border: 1px solid #000;
    margin-bottom: 15px;
    h1 {
      font-size: 15px;
      border-left: 5px solid @color;
      padding: 0 20px 0 10px;
      margin-bottom: 20px;
    }
    .box {
      cursor: pointer;
      width: 180px;
      height: 130px;
      border: 1.5px solid @color;
      margin: 0px 20px 20px 0px;
      padding: 11px;
      border-radius: 2px;
      box-sizing: border-box;
      text-align: left;
      border-radius: 10px;
      h2 {
        margin: 12px;
        // border: 1px solid #000;
        font-size: 14px;
        font-weight: 550;
      }
      h3 {
        // border: 1px solid #000;
        font-size: 13px;
        line-height: 25px;
      }
    }
    .box:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
